import axios from "axios";
import Router from '@/router/index'
import {message} from "ant-design-vue"
import store from '@/store'
const  key = {
    1:'productionUrl',
    2:'testUrl',
    3:'test1Url',
};
const address = {
    // 正式环境
    productionUrl : 'http://mainsys.springsc.cn/scm/',
    //本地环境
    testUrl:'http://localhost:8282/scm/', 
    // 测试环境
    test1Url:'https://mainsys.71baomu.com/scm/',
};

const model = key[window.model]

export const instance = axios.create({
    baseURL:address[model],
    headers: {
        "Content-Type": "application/json;charset=utf-8",
    },
    timeout: 30000,
    withCredentials: true, //请求头带cookie
})
instance.interceptors.request.use(
    request => {
        return request;
    }
)

instance.interceptors.response.use(
     response => {
        if (response.data.code == '510101') {
            message.warning("登录已过期，请重新登录",1,()=>{
                Router.push({name:'login'})
            } )
        } else if (response.data.code == '200001'||response.data.code == '510102') {
            store.commit('setMessageCount',response.headers['x-unread-notice-count']||0);
            // localStorage.setItem("messageCount",response.headers['x-unread-notice-count']||0)
            return response.data
        }else  {
            return response.data
        }
    },
    error => {
        return Promise.reject(error);
    }
);